/* fullpage.js extensions (needs to be loaded before core) */
require("./ThirdParty/fullpage/offsetSections/fullpage.offsetSections.min.js");
//require("./ThirdParty/fullpage/scrollOverflowReset/fullpage.scrollOverflowReset.min.js")

/* fullpage.js core */
const fullpage = require("fullpage.js/dist/fullpage.extensions.min.js");
require("fullpage.js/dist/fullpage.min.css");
$(".section.withDownArrow").each(function () {
  $("body").append(`<div class="fullpageNav"><button type="button" class="reset goToPrevSection text-lg"/><span class="sr-only">Previous Section</span><div class="mouse-arrow up"></div></button><div class="iconWrap"><i class="fa-thin fa-computer-mouse-scrollwheel"></i></div><button type="button" class="reset goToNextSection text-lg"/><span class="sr-only">Next Section</span><div class="mouse-arrow"></div></button></div>`);
});
var isMobile = false;
if (window.screen.width < 1024) {
  // Resolution is 1024x768 or above
  isMobile = true;
}
new fullpage('#main_content', {
  licenseKey: '29NSJ-K3L36-B1EK9-2EJY8-MRRMN',
  normalScrollElements: isMobile ? '' : '.scrollable',
  scrollBar: false,
  // needs to be false in order for overflow scrolling to work within sections
  scrollOverflow: !isMobile,
  //true,
  scrolloverflowmacstyle: false,
  responsiveWidth: 1024,
  beforeLeave: function (origin, destination, direction, trigger) {
    var item = destination.item;
    if ($(destination.item).hasClass("bg-white")) {
      $(".fullpageNav, .searchAndSocial").addClass("dark");
    } else {
      $(".fullpageNav, .searchAndSocial").removeClass("dark");
    }
    return true;

    // prevents scroll until we scroll 4 times
    //cont++;
    //return cont === 4;
  }
  //afterLoad: function (origin, destination, direction, trigger) {
  //    var origin = this;

  //    if (destination.item.classList.contains("homeExpertise")) {
  //        var expertiseScroller = destination.item.querySelector(".listView.expertises");
  //        if (expertiseScroller != null) {
  //            expertiseScroller.focus();
  //        }
  //    }
  //}
});
$('button.goToPrevSection').on("click", function () {
  fullpage_api.moveSectionUp();
});
$('button.goToNextSection').on("click", function () {
  fullpage_api.moveSectionDown();
});